import angular from 'angular';
import moment from 'moment';
import { toDate } from './helpers';

const minDateFallback = new Date(1900, 0, 1);

/*
Check minDate and maxDate on input based on datepickerOption values
 */
angular.module('cloudX').directive('uibDatepickerPopup', [
  '$window',
  '$filter',
  'relBindSvc',
  function($window, $filter, relBindSvc) {
    return {
      restrict: 'A',
      require: ['?ngModel', '^?bindErrors'],
      link: function(scope, element, attributes, ctrls) {
        let ngModel = ctrls[0];
        const bindErrors = ctrls[1];
        if (!ngModel) {
          const input = element.find('input[ng-model][uib-datepicker-popup]');
          if (!input || !input.length) return;
          ngModel = input.controller('ngModel');
          if (!ngModel) return;
        }
        if (typeof attributes.datepickerOptions !== 'undefined') {
          //Datepicker has options
          scope.$watch(
            attributes.datepickerOptions + '.minDate',
            minDateOption => {
              let minDate = toDate(minDateOption);
              if (typeof minDate === 'undefined' || minDate === null) minDate = minDateFallback;
              if (bindErrors) bindErrors.addError('min', 5, [$filter('formatDate')(minDate)]);

              ngModel.$validators.min = function(modelValue) {
                if (modelValue === null || modelValue === undefined) return true;
                var value = toDate(modelValue);
                if (typeof value === 'undefined' || value === null) return false;
                return value >= minDate;
              };
            },
            true,
          );
          scope.$watch(
            attributes.datepickerOptions + '.maxDate',
            maxDateOption => {
              const maxDate = toDate(maxDateOption);
              if (typeof maxDate === 'undefined' || maxDate === null) {
                //Clear validation if it exists
                delete ngModel.$validators.max;
                return true;
              }

              if (bindErrors) bindErrors.addError('max', 6, [$filter('formatDate')(maxDate)]);

              ngModel.$validators.max = function(modelValue) {
                if (modelValue === null || modelValue === undefined) return true;
                var value = toDate(modelValue);
                if (typeof value === 'undefined' || value === null) return false;
                return value <= maxDate;
              };
            },
            true,
          );
        } else {
          //Add minimum date validation

          if (bindErrors) bindErrors.addError('min', 5, [$filter('formatDate')(minDateFallback)]);

          ngModel.$validators.min = function(modelValue) {
            if (modelValue === null || modelValue === undefined) return true;
            var value = toDate(modelValue);
            if (typeof value === 'undefined' || value === null) return false;
            return value >= minDateFallback;
          };
        }
      },
    };
  },
]);
